import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { CustomDatePicker } from '../../../components/CustomDatePicker';
import { usePrevious } from '../../../custom-hooks';
import { EMPTY_INPUT_MASKS, getDateFormat, processInputValue } from '../../../utils/dateUtils';
import { DATE_FORMAT } from '../../constants/export.constants';

const DateInput = ({ date, handleSelectDate }) => {
  const [newValue, setValue] = useState(date);
  const [inputValue, setInputValue] = useState('');
  const [hasInputValueChanged, setInputValueChanged] = useState(false);
  const prevDateValue = usePrevious(date);

  const handleCalenderValueChange = (date) => {
    if (moment.isMoment(date)) {
      const formattedDate = date.format(DATE_FORMAT);
      handleSelectDate(formattedDate);

      setInputValueChanged(false);
      return;
    }
  };

  const submitInputValue = () => {
    const dateFormat = getDateFormat(newValue);
    const newInputDate = processInputValue(newValue, dateFormat);

    if (inputValue !== newInputDate && hasInputValueChanged) {
      handleSelectDate(inputValue);
    }
  };

  const handleInputChange = (newInputValue) => {
    if (newInputValue !== inputValue) {
      EMPTY_INPUT_MASKS.includes(newInputValue) ? setInputValue('') : setInputValue(newInputValue);
      setInputValueChanged(true);
    }
  };

  const handleNewInputValue = (value) => {
    const dateFormat = getDateFormat(value);
    const newInputDate = processInputValue(value, dateFormat);

    if (prevDateValue !== value || newInputDate !== inputValue) {
      setInputValue(newInputDate);
    }
  };

  useEffect(() => {
    setValue(date);
    handleNewInputValue(date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <CustomDatePicker
      storeValue={newValue}
      onChangeHandler={handleCalenderValueChange}
      onBlurHandler={submitInputValue}
      inputValue={inputValue}
      onInputChangeHandler={handleInputChange}
    />
  );
};

export default DateInput;
